var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.wordArray),function(keyword,i){return _c('v-chip',{key:i,staticClass:"mr-1",attrs:{"x-small":"","pill":"","color":"primary"}},[_vm._v(" #"+_vm._s(keyword)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }